<template>
  <div class="container">
    <!-- <div class="content"> -->
      <h2 class="title">{{ checkin_msg }}</h2>
      <div v-show="is_loading" class="loading">
          <grid-loader :loading="is_loading" :color="color"></grid-loader>
      </div>
      <div v-show="!is_loading" class="checkin-ok">
        <i :class="['ui', checkin_success ? 'check' : 'exclamation triangle', 'icon']"></i>
      </div>
    <!-- </div> -->
  </div>
</template>
<script>
import GridLoader from 'vue-spinner/src/GridLoader';
import moment from 'moment';
export default {
  components: {
    GridLoader
  },
  props: ['reqs'],
  data() {
    return {
      msg: 'Seu check-in foi finalizado. Por favor, dirija-se à recepção.',
      lang: 'pt-BR',
      checkin_msg: 'Efetuando Check-in!',
      is_loading: true,
      checkin_success: false,
      is_processing: false,
      color: 'white',
      return_timer: null
    }
  },
  mounted() {
    this.checkin();
  },
  beforeDestroy() {
    if (this.return_timer) clearTimeout(this.return_timer);
  },
  methods: {
    speak(msg) {
      if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) return;
      var utterThis = new SpeechSynthesisUtterance(msg);
      window.speechSynthesis.speak(utterThis);
    },
    finish(message, success, delay) {
      this.is_loading = false;
      this.checkin_success = success;
      this.checkin_msg = message;
      this.speak(message);
      this.return_timer = setTimeout(() => {
        this.$emit('buttonClicked', 'StartPage');
      }, delay || 10000);
    },
    createTicket(scheduling, today) {
      const oldTicket = scheduling.tickets && scheduling.tickets[0];
      if (oldTicket) {
        return {
          attendance_type_id: oldTicket.attendance_type_id,
          weight: oldTicket.weight,
          procedure_id: oldTicket.procedure_id,
          agreement_id: oldTicket.agreement_id,
          professional_id: oldTicket.professional_id,
          name: oldTicket.name,
          photo: oldTicket.photo,
          status: 'EE',
          user_id: oldTicket.user_id,
          customer_id: oldTicket.customer_id,
          source: '0',
          started_at: today
        };
      }
      const requisition = scheduling.requisition;
      if (!requisition || !requisition.customer) {
        throw new Error('Dados do agendamento incompletos');
      }
      return {
        attendance_type_id: requisition.type == 2 ? 2 : 1,
        weight: 0,
        procedure_id: scheduling.procedure_id,
        agreement_id: requisition.agreement_id,
        professional_id: scheduling.professional_id,
        customer_id: requisition.customer_id,
        name: requisition.customer.name,
        photo: requisition.customer.image,
        status: 'EE',
        user_id: null,
        source: '0',
        started_at: today
      };
    },
    async processScheduling(scheduling, today) {
      const updatedScheduling = Object.assign({}, scheduling, { date_checkin: today });
      if (scheduling.pendency == true) {
        updatedScheduling.authorized_checkin = false;
        const ticketResponse = await axios.post('api/kiosk/ticket', this.createTicket(scheduling, today));
        await axios.put('api/schedulingTicket', {
          scheduling_id: scheduling.id,
          ticket_id: [ticketResponse.data.data.id]
        });
      } else {
        updatedScheduling.msn_send1 = true;
        updatedScheduling.msn_send2 = true;
        updatedScheduling.msn_send3 = true;
      }
      await axios.put('api/kiosk/scheduling', updatedScheduling);
    },
    async getCompletionMessage(scheduling) {
      if (scheduling.pendency == true) {
        return 'Check-in realizado! Aguarde ser chamado pelo sistema de voz.';
      }
      const messageId = scheduling.professional && scheduling.professional.toten_message_id;
      if (!messageId) return 'Check-in realizado! Por favor, dirija-se à recepção.';
      try {
        const { data } = await axios.get('api/totenmessage/' + messageId);
        return 'Check-in realizado! ' + data.data.message;
      } catch (err) {
        return 'Check-in realizado! Por favor, dirija-se à recepção.';
      }
    },
    async checkin() {
      if (this.is_processing) return;
      this.is_processing = true;
      const schedulings = Array.isArray(this.reqs)
        ? this.reqs.filter(req => req.status == 0)
        : [];

      if (!schedulings.length) {
        this.finish('Não há agendamentos hoje para esse CPF ou telefone.', false, 6000);
        return;
      }

      const available = schedulings.filter(item => item.date_checkin == null && item.authorized_checkin == true);
      if (!available.length) {
        if (schedulings.some(item => item.date_checkin != null || item.authorized_checkin == false)) {
          this.finish('Check-in já realizado! Aguarde ser chamado pelo sistema de voz.', true, 6000);
        } else {
          this.finish('Check-in não disponível neste momento.', false, 6000);
        }
        return;
      }

      try {
        const today = moment().format('YYYY-MM-DD HH:mm:ss');
        for (const scheduling of available) {
          await this.processScheduling(scheduling, today);
        }
        const message = await this.getCompletionMessage(available[0]);
        this.finish(message, true, 10000);
      } catch (err) {
        this.finish('Não foi possível concluir o check-in. Por favor, procure a recepção.', false, 10000);
      }
    }
  }
}
</script>
<style scoped>
@media only screen and (min-width: 320px) {
  .checkin-ok {
    width: 50px;
  }
  .checkin-ok i {
    font-size: 48px;
  }
}

@media only screen and (min-width: 500px) {
  .container {
    position: absolute;
    top: 90%;
    left: 25%;
    width: 100%;
    margin: -24% 0 0 -25%;
  }
  .checkin-ok i {
    font-size: 80px;
  }
  h2 {
    font-size: 42px;
  }
}
h2 {
  color: #fff;
}
p {
  font-size: 36px;
  color: #fff;
  font-family: 'Source Sans Light';
  font-weight: bold;
}
.v-spinner {
  margin: 0 auto;
  font-size: 32px!important;
}
.checkin-ok {
  margin: 0 auto;
}
.checkin-ok i {
  margin-top: 20px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/FinishCheckin.vue